import * as types from '../constants/product'

export const changeProductCurrent = (data:any) => (dispatch:React.Dispatch<any>) => {
  dispatch({
    type: types.CHANGE_PRODUCT_CURRENT,
    payload: data,
  })
}